import { Component } from "react";
import { isBrowser } from "^/utils/isBrowser";

class GenericInputComponent extends Component {
  state = {
    value: "",
    checkBoxValues: {},
  };

  handleInputChange = (ev) => {
    const { value } = ev.target;
    this.changeValue(value);
  };

  changeValue = (value) => {
    const { widget, processAnswer } = this.props;

    if (widget.objClass() !== "CheckboxWidget") {
      const myStorage = isBrowser ? window.sessionStorage : {};
      myStorage.setItem(widget.id(), value);
      this.setState({
        value,
      });
    }

    processAnswer({
      widget,
      value,
    });
  };
}

export default GenericInputComponent;
